import { render, staticRenderFns } from "./ReservasIcon.vue?vue&type=template&id=699d41a8"
import script from "./ReservasIcon.vue?vue&type=script&lang=js"
export * from "./ReservasIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports